module.exports = __webpack_public_path__ + "img/emo_38.95ba7e7c.png";